// import React from "react";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { useTranslation } from "react-i18next";
import { UserTableModel, UserTableModelNames } from "../../models/tables.model";
import { Button } from "react-bootstrap";
import { UserManagementMerhantIdToName } from "../../utils/userManagment.util";
import { useUserManagmentContext } from "../../context/user.management.context";

function getStaticColumns(userTableData, translateFunction, setUserData, isGlobalUserAdmin, merchantNameAndId) {
  const columns = [
    {
      name: UserTableModelNames.user,
      grow: 2,
      //selector: (row) => [row[name]],
      //selector: (row) => row[UserTableModel.Status],
      sortable: true,
      cell: (row) => row[UserTableModel.username],
    },
    /* {
      name: UserTableModelNames.firstName,
      //selector: (row) => row[UserTableModel.firstName],
      cell: (row) => <div>{row[UserTableModel.firstName]}</div>,
      sortable: true,
    },
    {
      name: UserTableModelNames.lastName,
      //selector: (row) => row[UserTableModel.lastName],
      cell: (row) => <div className="font-weight-bold">{row[UserTableModel.lastName]}</div>,
      sortable: true,
    }, */
    isGlobalUserAdmin
      ? {
          name: UserTableModelNames.merchant,
          //selector: (row) => row[UserTableModel.merchant],
          //cell: (row) => <div className="font-weight-bold">{row[UserTableModel.merchant].join(", ")}</div>,
          cell: (row) => (
            <div className="font-weight-bold mg-y-5">
              {row?.merchantInfo?.map((info, index) => (
                <>
                  <div className=" mg-y-5 tx-15">{(row?.merchantInfo?.length > 1 ? index + 1 + ". " : "") + UserManagementMerhantIdToName(info?.merchantId, merchantNameAndId)}</div>
                </>
              ))}
            </div>
          ),
          sortable: true,
          grow: 2,
        }
      : { grow: 0 },
    {
      name: UserTableModelNames.role,
      //selector: (row) => row[UserTableModel.role],
      cell: (row) => (
        <div className="font-weight-bold">
          {row?.merchantInfo?.map((info, index) => (
            {/* <div className=" mg-y-5 tx-15">{(row.merchantInfo?.length > 1 ? index + 1 + ". " : "") + info?.role?.join(", ")}</div> */},
            <div className=" mg-y-5 tx-15">{(row.merchantInfo?.length > 1 ? index + 1 + ". " : "") + info?.role}</div>
          ))}
        </div>
      ),
      grow: 2,
      //cell: (row) => <div className="font-weight-bold">{row[UserTableModel.role].join(", ")}</div>,
      sortable: true,
    },
    {
      name: UserTableModelNames.editUser,
      cell: (row) => (
        <div className="font-weight-bold">
          <Button onClick={(e) => setUserData(row)}>Edit User</Button>
        </div>
      ),
      sortable: true,
    },
  ];

  return columns;
}

export function UsersTable({ userTableData, t, onTableDevicesClick, isGlobalUserAdmin, merchantName }) {
  const { t: translate } = useTranslation();

  const [dataToShow, setDataToShow] = useState();
  const [merch, setMerch] = useState()

  const {merchantNameAndId} = useUserManagmentContext();

  const setUserData = (data) => {
    onTableDevicesClick(data);
  };

  useEffect(() => {
    if (!isGlobalUserAdmin) {
      console.log("USER TABLE DATA => ", userTableData)

      setDataToShow(userTableData);
    } else {
      setDataToShow(userTableData);
      console.log("Merchant name in table => ", merchantName, merch)
    }
  }, [isGlobalUserAdmin, userTableData]);

  useEffect(() => {
    setMerch(merchantNameAndId)
  }, [merchantNameAndId])

  //console.log("USER MANAGEMENT TABLE DATA => ", dataToShow, merchantNameAndId)

  const columns = getStaticColumns(dataToShow, translate, setUserData, isGlobalUserAdmin, merch);

  const tableData = {
    columns,
    data: dataToShow,
  };

  return (
    // DataTableExtensions => (AddOn Lib for Search & Export)
    <DataTableExtensions {...tableData} filterPlaceholder="Search Table">
      <DataTable columns={tableData.columns} data={tableData.data} defaultSortAsc={false} center={true} pagination highlightOnHover />
    </DataTableExtensions>
  );
}
